// @ts-expect-error - Automatic, Please fix when editing this file
const selectMembership = (state) => state?.membership ?? null;

export default selectMembership;
